
<template>
  <!-- 此页已废弃，广告文件与广告任务功能删除 -->
  <div>
    <task-dialog :title="'添加广告任务'" ref="Dialog"></task-dialog>
    <el-button type="primary" size="mini" class="elinput" @click="$refs.Dialog.showDialog()">添加</el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top: 0.2rem"></xlsx>
    <!-- <p class="tabletitle"></p> -->
    <!-- <el-table
      :data="data"
      size="mini"
      height="650"
      id="out-table"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="35" :selectable="checkboxInit"></el-table-column>
      <el-table-column label="任务名">
        <template slot-scope="scope"></template>
      </el-table-column>
      <el-table-column label="任务描述">
        <template slot-scope="scope"></template>
      </el-table-column>
      <el-table-column label="任务完成进度(%)" sortable>
        <template slot-scope="scope"></template>
      </el-table-column>
      <el-table-column label="文件" sortable>
        <template slot-scope="scope"></template>
      </el-table-column>
      <el-table-column label="更新时间" sortable>
        <template slot-scope="scope"></template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope"></template>
      </el-table-column>
    </el-table> -->
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import TaskDialog from "@/components/taskDialog";
export default {
  data() {
    return {
      data: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      input: "",
      //分页组件参数
      total: 0,
      offset: 1,
      limit: 10
    };
  },
  components: {
    pagination,
    xlsx,
    TaskDialog
  },
  methods: {
    //分页组件
    SizeChanges(val) {
      console.log(val);
    },
    CurrentChanges(val) {
      console.log(val);
    },
    //搜索框禁止选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    //表格选择框
    handleSelectionChange(val) {
      console.log(val);
    }
  }
};
</script>

<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
.select {
  width: 3rem;
  margin: 0.2rem;
}

.rightcons {
  float: right;
}

.rightinput {
  display: inline-block;
  width: 3rem;
  margin: 0.2rem;
}

.concen {
  text-align: center;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}
.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
}
</style>
